<template>
  <div class="svg-container">
    <object type="image/svg+xml" :data="require('@/assets/svg/home11.svg')" class="svg-object" @load="onSvgLoad"
      @click="handleSvgClick"></object>
    <div v-if="showPopup" class="popup" :style="popupStyle">
      <div class="popup-content">
        <div class="popup-text"> {{ popupText }} </div>
        <div class="popup-text-content"> {{ popupContext }} </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SvgMapWithPopup',
  props: {
    dataClearEnergy: {
      type: Object,
      default: () => []
    },
  },
  watch: {
    dataClearEnergy: {
      handler(newVal) {
        console.log(newVal)
        this.dataList=newVal.children[3].children
      },
    },
  },
  data() {
    return {
      showPopup: false,
      popupText: '',
      popupContext:'',
      popupStyle: {
        left: '0px',
        top: '0px'
      },
      dataList:[],
      svgDoc: null,
      // 区域名称映射
      areaNames: {
        'path1': '西周镇',
        'path2': '高塘岛乡',
        'path3': '贤庠镇',
        'path4': '涂茨镇',
        'path5': '黄避岙乡',
        'path6': '墙头镇',
        'path7': '丹东街道',
        'path8': '丹西街道',
        'path9': '爵溪街道',
        'path10': '石浦港现代渔港片区',
        'path101': '石浦港现代渔港片区',
        'path11': '鹤浦镇',
        'path12': '高塘岛乡',
        'path13': '定塘镇',
        'path14': '晓塘乡',
        'path15': '新桥镇',
        'path16': '泗洲头镇',
        'path17': '茅洋乡',
        'path18': '东陈乡',
        'path66': '大目湾海洋科创片区',
        'path661': '大目湾海洋科创片区',
        'path663': '大目湾海洋科创片区',
        'path001': '象山港临港装备片区',
        'path002': '象山港临港装备片区',
        'path003': '象山港临港装备片区',
        'path004': '象山港临港装备片区',
        'path005': '象山港临港装备片区',
        'path006': '象山港临港装备片区',
        'path007': '象山港临港装备片区',
        'path008': '象山港临港装备片区',
      },
      // 区域集合映射
      areaGroups: {
        'group1': ['path10', 'path101'], // 石浦镇相关区域
        'group2': ['path66', 'path661', 'path663'], // 大目湾相关区域
        'group3': ['path001', 'path002', 'path003', 'path004', 'path005', 'path006', 'path007', 'path008'] // 临港区相关区域
      }
    }
  },
  methods: {
    onSvgLoad(event) {
      // 获取 SVG 文档对象
      this.svgDoc = event.target.contentDocument

      // 设置 SVG 背景为透明
      const svgElement = this.svgDoc.querySelector('svg')
      if (svgElement) {
        svgElement.style.backgroundColor = 'transparent'
        svgElement.style.fill = 'none'
        svgElement.style.background = 'transparent'
      }

      // 为所有区域添加交互类
      const areas = this.svgDoc.querySelectorAll('path, rect, circle, polygon')

      areas.forEach(area => {
        area.classList.add('map-area')
        // 获取区域的 id 或 class
        const areaId = area.id || area.className.baseVal

        // 从title元素中获取区域名称
        const titleElement = area.querySelector('title')
        const areaName = titleElement ? titleElement.textContent : this.areaNames[areaId] || '未命名区域'

        area.setAttribute('data-name', areaName)

        // 移除可能存在的旧事件监听器
        area.removeEventListener('mouseover', this.handleMouseOver)
        area.removeEventListener('mouseout', this.handleMouseOut)
        area.removeEventListener('click', this.handleSvgClick)

        // 添加鼠标事件
        area.addEventListener('mouseover', this.handleMouseOver)
        area.addEventListener('mouseout', this.handleMouseOut)
        area.addEventListener('click', (e) => {
          e.stopPropagation() // 阻止事件冒泡
          this.handleSvgClick(e)
        })
      })
    },
    getStreeInfo(name){
      let itemData=null
      if(this.dataClearEnergy.children[3].children){
        this.dataClearEnergy.children[3].children.forEach(item=>{
          if(name==item.configName){
            itemData=item
          }
        })
      }
      return itemData
    },
    handleSvgClick(event) {
      console.log('点击事件触发')
      console.log('目标元素:', event)
      console.log('目标元素类名:', event.target.className)
      console.log('目标元素ID:', event.target.id)

      // 阻止事件冒泡
      event.stopPropagation()

      const target = event.target
      if (target.classList.contains('map-area')) {
        const name = target.getAttribute('data-name')

        // 获取所有区域
        const allAreas = this.svgDoc.querySelectorAll('.map-area')

        // 重置所有区域的高亮状态
        allAreas.forEach(area => {
          area.style.filter = 'none'
        })

        // 查找点击区域所属的集合
        const clickedAreaId = target.id
        let groupToHighlight = []

        // 遍历所有集合，找到包含当前点击区域的集合
        Object.values(this.areaGroups).forEach(group => {
          if (group.includes(clickedAreaId)) {
            groupToHighlight = group
          }
        })

        // 高亮同一集合中的所有区域
        if (groupToHighlight.length > 0) {
          groupToHighlight.forEach(areaId => {
            const area = this.svgDoc.querySelector(`#${areaId}`)
            if (area) {
              area.style.filter = 'brightness(1.2)'
            }
          })
        }

        // 只有当区域名称不是"未命名区域"时才显示弹框
        if (name !== '未命名区域') {
          let info=this.getStreeInfo(name);
          console.log("街道"+JSON.stringify(info))
          if(info==null){
            this.$message && this.$message.info ? this.$message.info("暂无数据") : alert("暂无数据");
            return
          }
          
          const rect = target.getBoundingClientRect()
          const containerRect = this.$el.getBoundingClientRect()
          
          // 计算弹窗位置，根据点击区域位置显示
          this.popupStyle = {
            left: `${event.clientX - containerRect.left}px`,
            top: `${event.clientY - containerRect.top}px`
          }
          
          // 设置弹窗内容
          this.popupText = info.configName
          this.popupContext=info.configValue
          this.showPopup = true
          
          // 点击其他区域时关闭当前弹窗
          const closePopup = (e) => {
            if (!e.target.classList.contains('map-area')) {
              this.showPopup = false
              // 重置所有区域的高亮状态
              allAreas.forEach(area => {
                area.style.filter = 'none'
              })
              document.removeEventListener('click', closePopup)
            }
          }
          
          // 添加点击事件监听
          setTimeout(() => {
            document.addEventListener('click', closePopup)
          }, 0)
        } else {
          // 如果是未命名区域，确保弹框不显示
          this.showPopup = false
        }
      }
    },
    handleMouseOver(event) {
      const target = event.target
      if (target.classList.contains('map-area')) {
        target.style.cursor = 'pointer'
      }
    },
    handleMouseOut(event) {
      const target = event.target
      if (target.classList.contains('map-area')) {
        target.style.cursor = 'default'
      }
    }
  },
  beforeDestroy() {
    // 清理事件监听
    if (this.svgDoc) {
      const areas = this.svgDoc.querySelectorAll('.map-area')
      areas.forEach(area => {
        area.removeEventListener('mouseover', this.handleMouseOver)
        area.removeEventListener('mouseout', this.handleMouseOut)
      })
    }
  }
}
</script>

<style scoped>
.svg-container {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 0;
  background: transparent;
  margin: 0 auto;
  padding: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.svg-object {
  width: 100%;
  height: 100%;
  pointer-events: all;
  background: transparent;
  display: block;
  object-fit: contain;
}

.popup {
  position: absolute;
  color: white;
  width: 345px;
  pointer-events: none;
  z-index: 1000;
  white-space: nowrap;
  animation: fadeIn 0.3s ease;
}

.popup-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.popup-text {
  height: 45px;
  width: 345px;
  background-color: white;
  color: black;
  padding-left: 10px;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  line-height: 45px;
}

.popup-text-content {
  word-break: break-all;
  word-wrap: break-word;
  white-space: pre-line;
  width: 345px;
  overflow: auto;
  padding-left: 10px;
  color: white;
  font-size: 14px;
  min-height: 260px;
  background: linear-gradient(180deg, #1149FC 0%, #03C9F6 100%);
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

:deep(.map-area) {
  transition: all 0.3s ease;
}

:deep(.map-area:hover) {
  filter: brightness(1.2);
  cursor: pointer;
}
</style>